/* eslint-disable react/prefer-es6-class, react/sort-comp, quote-props */
import classnames from 'classnames';
import React from 'react';

import { t } from 'es6/services/localization';
import { formatNumber } from 'es6/helpers/numbers';

const StudyProgress = React.createClass({
  displayName: 'StudyProgress',

  propTypes: {
    cumulatives: React.PropTypes.object,
  },

  render() {
    const className = classnames('study-progress', { 'waiting': !this.props.cumulatives });

    let itemsStarted = '-';
    let itemsCheckpoint0 = '-';
    let itemsCheckpoint1 = '-';
    let itemsCheckpoint2 = '-';

    if (this.props.cumulatives) {
      const itemsCumulatives = this.props.cumulatives.items;
      itemsStarted = formatNumber(itemsCumulatives.cumulativeItemsStarted);
      itemsCheckpoint0 = formatNumber(itemsCumulatives.cumulativeItemsStarted - itemsCumulatives.cumulativeItemsReachedCheckpoint1);
      itemsCheckpoint1 = formatNumber(itemsCumulatives.cumulativeItemsReachedCheckpoint1 - itemsCumulatives.cumulativeItemsReachedCheckpoint2);
      itemsCheckpoint2 = formatNumber(itemsCumulatives.cumulativeItemsReachedCheckpoint2);
    }

    return (
      <div className={className}>
        <header className="content-details">
          <div className="details-primary alone">{t('dashboard.study-progress')}</div>
        </header>

        <div className="content-primary">
          <ul className="content-list content-stats">
            {this._renderStat('checkpoint-0', itemsCheckpoint0, t('study-progress.items-zone-0'))}
            {this._renderStat('checkpoint-1', itemsCheckpoint1, t('study-progress.items-zone-1'))}
            {this._renderStat('checkpoint-2', itemsCheckpoint2, t('study-progress.items-zone-2'))}
            {this._renderStat('total', itemsStarted, t('study-progress.items-started'))}
          </ul>
        </div>
      </div>
    );
  },

  _renderStat(type, primary, secondary) {
    return (
      <li className={`list-item stat ${type}`}>
        <aside className="accent"></aside>
        <span className="primary">{primary}</span>
        <span className="secondary">{secondary}</span>
      </li>
    );
  },
});

export default StudyProgress;
